export default __webpack_public_path__ + "static/media/trafficsafety-bg2-textbox.6e3ffdfb.png";